import React, { Component } from 'react';
import { Icon, Collapsible, CollapsibleItem } from 'react-materialize';
import { withRouter } from 'react-router';

import Properties from '../../components/properties/Properties';
import ImageViewer from '../../components/image-viewer/ImageViewer';
import PDFViewer from '../../components/pdf-viewer/PDFViewer';
import FileUtils from '../../utils/FileUtils';
import CommonConstants from '../../constants/CommonConstants';

import './AssetDetails.css';

const ARCHIVE_ASSET_PROPERTIES_TO_SHOW = [
  {
    displayName: 'Source Application',
    name: 'archive_file:archiveApplication.id'
  },
  {
    displayName: 'File Type',
    name: 'archive_file:archiveClassification.id'
  },
  {
    displayName: 'Archive Submission Title',
    name: 'archive_file:archiveSubmission.title'
  },
  {
    displayName: 'File Version Type',
    name: 'archive_file:archiveVersionCategory'
  },
  {
    displayName: 'Submission ID',
    name: 'archive_file:archiveSubmissionId'
  },
  {
    displayName: 'Submission Stage',
    name: 'archive_file:archiveSubmissionStage'
  },
  {
    displayName: 'Submission Date',
    name: 'archive_file:archiveSubmissionDate',
    type: Properties.DATE_TYPE
  }
];

const ARCHIVE_SUBMISSION_PROPERTIES_TO_SHOW = [
  {
    displayName: 'Line of Business',
    name: 'archive_submission:lineOfBusiness'
  },
  {
    displayName: 'Workfront Project Job ID',
    name: 'archive_submission:workfrontProjectJobId'
  },
  {
    displayName: 'Contract',
    name: 'archive_submission:contract'
  },
  {
    displayName: 'Product Category ID',
    name: 'archive_submission:productCategoryId'
  },
  {
    displayName: 'Product Category Name',
    name: 'archive_submission:productCategoryName'
  },
  {
    displayName: 'Product Type ID',
    name: 'archive_submission:productTypeId'
  },
  {
    displayName: 'Product Type Name',
    name: 'archive_submission:productTypeName'
  },
  {
    displayName: 'Product Detail ID',
    name: 'archive_submission:productDetailId'
  },
  {
    displayName: 'Product Detail Name',
    name: 'archive_submission:productDetailName'
  },
  {
    displayName: 'Workfront Project ID',
    name: 'archive_submission:workfrontProjectId'
  },
  {
    displayName: 'Licensee Ref #',
    name: 'archive_submission:licenseeRefNo'
  },
  {
    displayName: 'LicenseeName',
    name: 'archive_submission:licenseeName'
  },
  {
    displayName: 'Licensee Phone',
    name: 'archive_submission:licenseePhone'
  },
  {
    displayName: 'Licensee Fax',
    name: 'archive_submission:licenseeFax'
  },
  {
    displayName: 'Licensee E-Mail',
    name: 'archive_submission:licenseeEmail'
  },
  {
    displayName: 'Licensee Contact Name',
    name: 'archive_submission:licenseeContactName'
  },
  {
    displayName: 'Property',
    name: 'archive_submission:property'
  },
  {
    displayName: 'Property Name',
    name: 'archive_submission:propertyName'
  },
  {
    displayName: 'Territory',
    name: 'archive_submission:territory'
  },
  {
    displayName: 'Contract Status',
    name: 'archive_submission:contractStatus'
  },
  {
    displayName: 'Art Program',
    name: 'archive_submission:artProgram'
  },
  {
    displayName: 'AE Name',
    name: 'archive_submission:aeName'
  },
  {
    displayName: 'BA Rep',
    name: 'archive_submission:baRep'
  },
  {
    displayName: 'PD',
    name: 'archive_submission:pd'
  },
  {
    displayName: 'Description',
    name: 'dc:description'
  },
  {
    displayName: 'Asset Title',
    name: 'dc:title'
  },
  {
    displayName: 'Coordinator',
    name: 'archive_submission:coordinator'
  },
  {
    displayName: 'Job Status',
    name: 'archive_submission:jobStatus'
  },
  {
    displayName: 'Licensee',
    name: 'archive_submission:licensee'
  },
  {
    displayName: 'Retailer',
    name: 'archive_submission:retailer'
  },
  {
    displayName: 'LMSI Office',
    name: 'archive_submission:lmsiOffice'
  },
  {
    displayName: 'Job Stage',
    name: 'archive_submission:jobStage'
  },
  {
    displayName: 'Job Category',
    name: 'archive_submission:jobCategory'
  },
  {
    displayName: 'Job Start Date',
    name: 'archive_submission:jobStartDate',
    type: Properties.DATE_TYPE
  },
  {
    displayName: 'Character',
    name: 'archive_submission:character'
  },
  {
    displayName: 'Job Stage Category',
    name: 'archive_submission:jobStageCategory'
  },
  {
    displayName: 'Job Last Status Date',
    name: 'archive_submission:jobLastStatusDate',
    type: Properties.DATE_TYPE
  }
];

const ACTIVE_ASSET_PROPERTIES_TO_SHOW = [
  {
    displayName: 'Source Application',
    name: 'live_file:sourceApplication'
  },
  {
    displayName: 'Live Classification',
    name: 'live_file:liveClassification'
  },
  {
    displayName: 'Workfront Project Job ID',
    name: 'live_file:workfrontProjectJobId'
  },
  {
    displayName: 'STAR LABS Submission Title',
    name: 'live_file:liveSubmissionTitle'
  }
];

const ACTIVE_SUBMISSION_PROPERTIES_TO_SHOW = [
  {
    displayName: 'Line of Business',
    name: 'submission:lineOfBusiness'
  },
  {
    displayName: 'Workfront Project Job ID',
    name: 'submission:workfrontProjectJobId'
  },
  {
    displayName: 'Contract',
    name: 'submission:contract'
  },
  {
    displayName: 'Product Category ID',
    name: 'submission:productCategoryId'
  },
  {
    displayName: 'Product Category Name',
    name: 'submission:productCategoryName'
  },
  {
    displayName: 'Product Type ID',
    name: 'submission:productTypeId'
  },
  {
    displayName: 'Product Type Name',
    name: 'submission:productTypeName'
  },
  {
    displayName: 'Product Detail ID',
    name: 'submission:productDetailId'
  },
  {
    displayName: 'Product Detail Name',
    name: 'submission:productDetailName'
  },
  {
    displayName: 'Workfront Project ID',
    name: 'submission:workfrontProjectId'
  },
  {
    displayName: 'Licensee Ref #',
    name: 'submission:licenseeRefNo'
  },
  {
    displayName: 'LicenseeName',
    name: 'submission:licenseeName'
  },
  {
    displayName: 'Licensee Phone',
    name: 'submission:licenseePhone'
  },
  {
    displayName: 'Licensee Fax',
    name: 'submission:licenseeFax'
  },
  {
    displayName: 'Licensee E-Mail',
    name: 'submission:licenseeEmail'
  },
  {
    displayName: 'Licensee Contact Name',
    name: 'submission:licenseeContactName'
  },
  {
    displayName: 'Property',
    name: 'submission:property'
  },
  {
    displayName: 'Property Name',
    name: 'submission:propertyName'
  },
  {
    displayName: 'Territory',
    name: 'submission:territory'
  },
  {
    displayName: 'Contract Status',
    name: 'submission:contractStatus'
  },
  {
    displayName: 'Art Program',
    name: 'submission:artProgram'
  },
  {
    displayName: 'AE Name',
    name: 'submission:aeName'
  },
  {
    displayName: 'BA Rep',
    name: 'submission:baRep'
  },
  {
    displayName: 'PD',
    name: 'submission:pd'
  },
  {
    displayName: 'Description',
    name: 'dc:description'
  },
  {
    displayName: 'Asset Title',
    name: 'dc:title'
  },
  {
    displayName: 'Coordinator',
    name: 'submission:coordinator'
  },
  {
    displayName: 'Job Status',
    name: 'submission:jobStatus'
  },
  {
    displayName: 'Licensee',
    name: 'submission:licensee'
  },
  {
    displayName: 'Retailer',
    name: 'submission:retailer'
  },
  {
    displayName: 'LMSI Office',
    name: 'submission:lmsiOffice'
  },
  {
    displayName: 'Job Stage',
    name: 'submission:jobStage'
  },
  {
    displayName: 'Job Category',
    name: 'submission:jobCategory'
  },
  {
    displayName: 'Job Start Date',
    name: 'submission:jobStartDate',
    type: Properties.DATE_TYPE
  },
  {
    displayName: 'Character',
    name: 'submission:character'
  },
  {
    displayName: 'Job Stage Category',
    name: 'submission:jobStageCategory'
  },
  {
    displayName: 'Job Last Status Date',
    name: 'submission:jobLastStatusDate',
    type: Properties.DATE_TYPE
  }
];

class AssetDetails extends Component {
  constructor(props){
    super(props);

    this._handleAssetBackClick = this._handleAssetBackClick.bind(this);
  }

  _handleAssetBackClick(){
    window.history.pushState({}, null, this.props.location.pathname);
  }

  render() {
    const hrefLink = "#"
    const { asset, type } = this.props;

    if (!asset) {
      return (<div/>);
    }
    
    //const assetFile = type=== CommonConstants.ARCHIVE_ASSETS_FILE_TYPE ? asset['file:content'] : asset['picture:views'][CommonConstants.FILE_VIEWS_ORIGINAL].content;

    const assetFile = asset['file:content'] ? asset['file:content'] : asset['picture:views'][CommonConstants.FILE_VIEWS_ORIGINAL].content;

    const ASSET_PROPERTIES_TO_SHOW = type=== CommonConstants.ARCHIVE_ASSETS_FILE_TYPE ? ARCHIVE_ASSET_PROPERTIES_TO_SHOW : ACTIVE_ASSET_PROPERTIES_TO_SHOW;

    const SUBMISSION_PROPERTIES_TO_SHOW = type=== CommonConstants.ARCHIVE_ASSETS_FILE_TYPE ? ARCHIVE_SUBMISSION_PROPERTIES_TO_SHOW : ACTIVE_SUBMISSION_PROPERTIES_TO_SHOW;

    return (
      <div className="asset-details">
        <div className="main">
          <header className="main-header">
            <a href={hrefLink} className="btn-link" onClick={ this._handleAssetBackClick }>
              <Icon tiny>arrow_back</Icon> Back
            </a>
          </header>
          
          { assetFile['mime-type'] === 'application/pdf' ? <PDFViewer file={ assetFile.data } /> : <ImageViewer image={ asset['picture:views'][CommonConstants.FILE_VIEWS_ORIGINAL].content.data }/> }

          <div className="row">
            <div className="info">
              <h2 className="title">{ assetFile.name }</h2>
              <h2 className="sub-title">{ FileUtils.getHumanReadableSize(assetFile.length) }</h2>
            </div>
            <div className="actions">
              <a className="link" href={ assetFile.data } target="_blank" rel="noopener noreferrer">
                <div>
                  <Icon small>file_download</Icon> 
                </div>
              </a>
            </div>
          </div>
        </div>
        <div className="side">
          <Collapsible accordion defaultActiveKey={ 0 }>
            <CollapsibleItem header="Asset Information">
              <Properties object={ asset } properties={ ASSET_PROPERTIES_TO_SHOW }></Properties>
            </CollapsibleItem>
            <CollapsibleItem header="Submission Information">
              <Properties object={ asset } properties={ SUBMISSION_PROPERTIES_TO_SHOW }></Properties>
            </CollapsibleItem>
          </Collapsible>
        </div>
      </div>
    );
  }
}

export default withRouter(AssetDetails);